// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===================================
   Authenticated Layout
   Flat Design System
   =================================== */

.auth-layout--loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background: var(--color-bg-root);
}

/* Loading spinner */
.auth-layout__loader {
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-layout__spinner {
  width: 28px;
  height: 28px;
  border: 2px solid var(--color-border-input);
  border-top-color: var(--color-text-secondary);
  border-radius: 50%;
  animation: authLayoutSpin 0.8s linear infinite;
}

@keyframes authLayoutSpin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AuthenticatedLayout.css"],"names":[],"mappings":"AAAA;;;wCAGwC;;AAExC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,6CAA6C;EAC7C,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["/* ===================================\n   Authenticated Layout\n   Flat Design System\n   =================================== */\n\n.auth-layout--loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 100%;\n  background: var(--color-bg-root);\n}\n\n/* Loading spinner */\n.auth-layout__loader {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-layout__spinner {\n  width: 28px;\n  height: 28px;\n  border: 2px solid var(--color-border-input);\n  border-top-color: var(--color-text-secondary);\n  border-radius: 50%;\n  animation: authLayoutSpin 0.8s linear infinite;\n}\n\n@keyframes authLayoutSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
